import { qs, qsa } from "../inc/dom.js";
import { initTimeline } from "../inc/timeline.js";

const initHistoryNav = () => {
    const modals = qsa("[data-history-index]");
    if (modals.length < 2) return;
    const rail = qs("[data-timeline]");
    const items = rail ? qsa(".timeline-item", rail) : [];

    const slides = modals.map((modal) => ({
        index: Number(modal.dataset.historyIndex),
        html: qs(".modal-body", modal).innerHTML,
    }));

    const syncTimeline = (entryIndex) => {
        if (!items.length) return;
        const item = items[entryIndex - 1];
        if (!item) return;
        items.forEach((el) => el.classList.toggle("is-current", el === item));
        item.classList.add("is-revealed");
        if (!rail || getComputedStyle(rail).overflowX === "visible") return;
        const railRect = rail.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const max = rail.scrollWidth - rail.clientWidth;
        const left =
            rail.scrollLeft +
            (itemRect.left - railRect.left) -
            (rail.clientWidth - itemRect.width) / 2;
        rail.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: "auto" });
    };

    const render = (modal, position) => {
        const slide = slides[position];
        if (!slide) return;
        qs(".modal-body", modal).innerHTML = slide.html;
        modal.dataset.historyPosition = String(position);
        const prev = qs("[data-history-prev]", modal);
        const next = qs("[data-history-next]", modal);
        const year = qs("[data-history-year]", modal);
        const label = qs(".section-prehead", modal);
        if (prev) prev.disabled = position === 0;
        if (next) next.disabled = position === slides.length - 1;
        if (year && label) year.textContent = label.textContent;
        syncTimeline(slide.index);
    };

    modals.forEach((modal, home) => {
        const step = (delta) =>
            render(modal, Number(modal.dataset.historyPosition) + delta);
        const prev = qs("[data-history-prev]", modal);
        const next = qs("[data-history-next]", modal);
        if (prev) prev.addEventListener("click", () => step(-1));
        if (next) next.addEventListener("click", () => step(1));
        modal.addEventListener("show.bs.modal", () => render(modal, home));
    });
};

initTimeline();
initHistoryNav();
